export default {
    jqlFilterText: (state) => state.jqlFilterText,
    wiqlFilterText: (state) => state.wiqlFilterText,
    jiraFilteringEnabled: (state) => state.jiraFilteringEnabled,
    azureFilteringEnabled: (state) => state.azureFilteringEnabled,
    jqlAppendix: (state) => state.jqlAppendix,
    wiqlAppendix: (state) => state.wiqlAppendix,
    jqlTestResult: (state) => state.jqlTestResult,
    wiqlTestResult: (state) => state.wiqlTestResult,
    loaderVisible: (state) => state.loaderVisible,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/filters/getters.js